import { FOOTER_LINKS, SOCIALS } from '@Web/Pages/Web/Layout/Components/Footer/constants.jsx';
import { MEDALS, SECURITY_MEDALS } from '@Web/Src/constants.js';
import Collapse from '@Shared/Ui/Collapse';
import { Link } from '@inertiajs/react';
import ImageLazy from '@Web/Src/Components/Image/Lazy/index.jsx';

function FooterLink({ item }) {
    const commonProps = {
        href: item.url,
        target: item.newTab ? '_blank' : '_self',
        className: 'block mt-3 w-52 text-sm !cursor-pointer hover:underline',
        children: item.text,
    };

    return item.external ? <a {...commonProps} /> : <Link {...commonProps} />;
}

function handleOpenTrustWebsite() {
    window.open('https://trust.referral-factory.com', '_blank', 'noopener, noreferrer');
}

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className='page-container mx-auto !mt-40 font-sans'>
            <div className='bg-surface-dark medium:px-8 small:px-4 w-full rounded-3xl px-24'>
                <div className='flex w-full justify-center pt-10'>
                    <img
                        src={'/assets/images/svg/logo_white.svg'}
                        alt='referral-factory logo'
                        className='w-[125px]'
                    />
                </div>
                <div className='mx-auto my-12 flex max-w-[760px] flex-wrap justify-center'>
                    {MEDALS.filter((item) => !item.hideOnFooter).map((item, index) => {
                        return (
                            <div key={index} className={'-mx-3 max-w-32 flex-shrink-0'}>
                                <ImageLazy
                                    className={`!w-full`}
                                    src={item.img}
                                    lowSrc={item.imgLow}
                                    alt={item.alt || 'Certificate'}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className='!h-[1px] !bg-[#738199]' />
                <p className='text-light mt-12 text-center font-bold'>
                    {__('Enterprise Level Security On All Plans')}
                </p>
                <div className='mx-auto my-8 mt-4 flex max-w-[760px] flex-wrap justify-center'>
                    {SECURITY_MEDALS.map((item, index) => {
                        return (
                            <div key={index} className={'-mx-3 max-w-32 flex-shrink-0'}>
                                <ImageLazy
                                    className={`!w-full`}
                                    src={item.img}
                                    lowSrc={item.imgLow}
                                    alt={item.alt || 'Certificate'}
                                />
                            </div>
                        );
                    })}
                </div>

                <div className='!h-[1px] !bg-[#738199]' />

                <div className='medium:block hidden w-full py-10'>
                    <Collapse
                        className='text-light mt-2'
                        title={FOOTER_LINKS.legals.title}
                        height='h-8'
                    >
                        {FOOTER_LINKS.legals.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                        <span
                            onClick={handleOpenTrustWebsite}
                            className='mt-3 block w-52 cursor-pointer text-sm hover:underline'
                        >
                            {__('Security & Compliance')}
                        </span>
                    </Collapse>
                    <Collapse
                        height='h-8'
                        className='text-light mt-2'
                        title={FOOTER_LINKS.product.title}
                    >
                        {FOOTER_LINKS.product.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                    </Collapse>
                    <Collapse
                        height='h-8'
                        className='text-light mt-2'
                        title={FOOTER_LINKS.tools.title}
                    >
                        {FOOTER_LINKS.tools.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                    </Collapse>
                    <Collapse
                        height='h-8'
                        className='text-light mt-2'
                        title={FOOTER_LINKS.quick_links.title}
                    >
                        {FOOTER_LINKS.quick_links.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                    </Collapse>
                    <Collapse
                        height='h-8'
                        className='text-light mt-2'
                        title={FOOTER_LINKS.affiliates.title}
                    >
                        {FOOTER_LINKS.affiliates.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                    </Collapse>
                    <div className='text-light mt-10 px-6'>
                        <p className='font-semibold'>{FOOTER_LINKS.find_us.title}</p>

                        {FOOTER_LINKS.find_us.links.map((item, index) => (
                            <FooterLink item={item} key={index} />
                        ))}
                    </div>
                </div>

                <div className='text-light medium:hidden small:px-12 block px-0 py-12'>
                    <div className='small:justify-between flex flex-wrap justify-center gap-20'>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.legals.title}</p>
                            {FOOTER_LINKS.legals.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                            <span
                                onClick={handleOpenTrustWebsite}
                                className='mt-3 w-52 cursor-pointer text-sm hover:underline'
                            >
                                {__('Security & Compliance')}
                            </span>
                        </div>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.product.title}</p>
                            {FOOTER_LINKS.product.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                        </div>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.tools.title}</p>
                            {FOOTER_LINKS.tools.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                        </div>
                    </div>
                    <div className='small:justify-between mt-12 flex flex-wrap justify-center gap-20'>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.quick_links.title}</p>
                            {FOOTER_LINKS.quick_links.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                        </div>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.affiliates.title}</p>
                            {FOOTER_LINKS.affiliates.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                        </div>
                        <div className='flex flex-col'>
                            <p className='font-semibold'>{FOOTER_LINKS.find_us.title}</p>
                            {FOOTER_LINKS.find_us.links.map((item, index) => (
                                <FooterLink item={item} key={index} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='small:justify-center flex flex-wrap items-center justify-between gap-5 p-8'>
                <p>
                    {__('© :currentYear Referral Factory BV. All Rights Reserved.', {
                        currentYear,
                    })}
                </p>
                <div className='flex items-center gap-2'>
                    {SOCIALS.map((item, index) => {
                        return (
                            <img
                                onClick={() =>
                                    window.open(item.url, '_blank', 'noopener, noreferrer')
                                }
                                className='cursor-pointer'
                                key={index}
                                src={item.img}
                                alt={item.alt}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Footer;
